<p class="header">{{ 'stt.modalEdit.edition' | translate }}</p>
<div class="content">
    <div class="col md-12">
        <div class="titles mb-2">
            <ul>
                <li>
                    <p>{{ 'stt.modalEdit.file' | translate }}</p>
                </li>
                <li>
                    <p>{{ 'stt.modalEdit.edit' | translate }}</p>
                </li>
                <li>
                    <p>{{ 'stt.modalEdit.date' | translate }}</p>
                </li>
                <li>
                    <p>{{ 'stt.modalEdit.action' | translate }}</p>
                </li>
            </ul>
        </div>
        <div class="d-flex justify-content-center spinner-content" *ngIf ="transcriptions == null ; else cualquierCosa">
            <div class="py-5">
                <mat-spinner [diameter]="70" [strokeWidth]="2"></mat-spinner>
            </div>
        </div>
        <ng-template #cualquierCosa>
            <div class="list-result" *ngFor="let transcription of obs | async;">
                <ul>
                    <li>
                        <p>{{ transcription.Version }}</p>
                    </li>
                    <li>
                        <p>{{ transcription.ModifyBy }}</p>
                    </li>
                    <li>
                        <p>{{ transcription.ModifyDate | date: "MM/dd/yyyy"}}</p>
                    </li>
                    <li><a class="ver" [ngClass]="transcription.Selected ? 'button-secondary-blue':'button-secondary' " (click)="ShowDetails(transcription)">{{ 'stt.modalEdit.watch' | translate }}</a></li>
                </ul>
            </div>
            <mat-paginator *ngIf="transcriptions?.length > 5" [pageSize]="5"></mat-paginator>
        </ng-template>
    </div>

     <div class="text-block" *ngIf="transcriptionSelected != null">
        <p><strong class="subtitles">{{ 'stt.modalEdit.speaker' | translate }}: {{ transcriptionSelected.Orador }} / {{ transcriptionSelected.SentenceDate }}</strong></p>
        <p><strong class="subtitles">{{ 'stt.modalEdit.speakEdit' | translate }}: {{ transcriptionSelected.ModifyBy }} / {{ transcriptionSelected.ModifyDate }}</strong></p>
        <p class="text">{{ transcriptionSelected.Text }}</p>
    </div>

    <div class="buttons-box">
        <a class="button-primary" mat-dialog-close>{{ 'stt.modalEdit.close' | translate }}</a>
    </div>
</div>
